(ns ncr.fragment-types.attachments-editor-preview
  (:require
   [ncr.etc.pf :as pf]
   [ncr.widgets.core :as w]
   [ncr.fragment-types.pdf-viewer :as pdf-viewer]
   [ncr.fragment-types.img-viewer :as img-viewer]
   [ncr.fragment-types.txt-viewer :as txt-viewer]
   [ncr.fragment-types.unsupported-viewer :as unsupported-viewer]))

(defn c-viewer [fragment-name {:keys [type url id]} close attachments set-preview]
  (let
    [attachment (some #(when (= id (:id %)) %) attachments)
     c-viewer'
     (when (string? url)
       (cond
         (= "application/pdf" type) pdf-viewer/c-viewer
         (= "text/plain" type) txt-viewer/c-viewer
         (re-find #"^image/.+" type) img-viewer/c-viewer
         :else unsupported-viewer/c-viewer))]
    [pf/l-flex
     {:class
      [:pf-u-h-100
       :ncr-c-attachment-viewer
       (when (= txt-viewer/c-viewer c-viewer')
         :ncr-c-attachment-viewer-scrollable)]
      :direction :column}
     (if (some? c-viewer')
       [c-viewer' fragment-name attachment url close attachments set-preview]
       [pf/c-empty-state
        [pf/c-empty-state-icon
         {:variant :container
          :component [w/c-mdi-icon {:icon :alert-circle-outline}]}]
        [pf/c-title {:heading-level :h4 :size :lg} "Error loading file"]
        [pf/c-empty-state-body (str url)]
        [pf/c-button
         {:variant :primary
          :on-click (fn [_] (close))}
         "Close"]])]))
